export const PLATFORM_COLORS: Record<string, string> = {
  linkedin: "#0A66C2",
  whatsapp: "#25D366",
  facebook: "#0866FF",
  youtube: "#FF0000",
  instagram: "#E1306C",
  tiktok: "#010101",
  x: "#000000",
  telegram: "#26A5E4",
  google: "#4285F4",
  bing: "#008373",
};

export const TRAFFIC_LABEL_COLORS: Record<string, string> = {
  LinkedIn: PLATFORM_COLORS.linkedin,
  WhatsApp: PLATFORM_COLORS.whatsapp,
  Facebook: PLATFORM_COLORS.facebook,
  YouTube: PLATFORM_COLORS.youtube,
  Instagram: PLATFORM_COLORS.instagram,
  TikTok: PLATFORM_COLORS.tiktok,
  "X (Twitter)": PLATFORM_COLORS.x,
  Telegram: PLATFORM_COLORS.telegram,
  Google: PLATFORM_COLORS.google,
  Bing: PLATFORM_COLORS.bing,
  Directo: "#9CA3AF",
  Otros: "#D1D5DB",
};

export const TRAFFIC_FALLBACK_COLORS = [
  "#3b82f6",
  "#10b981",
  "#8b5cf6",
  "#f59e0b",
  "#06b6d4",
  "#f43f5e",
];
